import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

const useClasses = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    marginTop: theme.spacing(2),
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: "1.2rem",
  },
  title: {
    fontWeight: "bold",
  },
}));

const SectionTitle = ({ icon: Icon, children }) => {
  const classes = useClasses();

  return (
    <Box className={classes.container}>
      {Icon && <Icon className={classes.icon} />}
      <Typography
        variant="subtitle1"
        className={classes.title}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default SectionTitle;
